import React from 'react';
import Joyride, { CallBackProps, STATUS } from 'react-joyride';
import { useTour } from '../contexts/TourContext';
import { useAuth } from '../contexts/AuthContext';
import { getTourSteps } from '../tour/tourSteps';

const GuidedTour: React.FC = () => {
  const { isTourActive, endTour } = useTour();
  const { user } = useAuth();

  if (!user || !isTourActive) return null;

  const steps = getTourSteps(user.role);

  const handleCallback = (data: CallBackProps) => {
    const { status } = data;
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      endTour();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={isTourActive}
      continuous
      showProgress
      showSkipButton
      scrollToFirstStep
      disableOverlayClose
      callback={handleCallback}
      styles={{
        options: {
          primaryColor: '#1E4D7B',
          zIndex: 10000,
          arrowColor: '#fff',
          backgroundColor: '#fff',
          textColor: '#1f2937',
          overlayColor: 'rgba(0, 0, 0, 0.5)',
        },
        tooltip: {
          borderRadius: '12px',
          padding: '20px',
          fontSize: '14px',
        },
        tooltipTitle: {
          fontSize: '16px',
          fontWeight: 600,
          color: '#1E4D7B',
          marginBottom: '8px',
        },
        tooltipContent: {
          padding: '8px 0',
          lineHeight: '1.5',
        },
        buttonNext: {
          backgroundColor: '#1E4D7B',
          borderRadius: '8px',
          padding: '8px 18px',
          fontSize: '13px',
          fontWeight: 500,
        },
        buttonBack: {
          color: '#6b7280',
          fontSize: '13px',
          fontWeight: 500,
        },
        buttonSkip: {
          color: '#9ca3af',
          fontSize: '13px',
        },
        spotlight: {
          borderRadius: '8px',
        },
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Finish',
        next: 'Next',
        skip: 'Skip Tour',
      }}
    />
  );
};

export default GuidedTour;
